<template>
  <!-- The point system, told once and everywhere the same (re-ruled
       2026-09-13): the three earnings as ONE quiet strip, then the ladder as
       BARS — each stage fills toward the number at its end, so "full" always
       has a name. Points count per submission; a certified 예약 counts like
       a direct use. Frame-agnostic: the rank pill's popover and the log's
       level layer both render this block. -->
  <div class="elg">
    <p class="elg__h ko">포인트</p>
    <div class="elg__strip">
      <div class="elg__cell"><span class="ko">배운 표현</span><b class="ko">+1점</b></div>
      <div class="elg__cell"><span class="ko">노출 기록</span><b class="ko">+2점</b></div>
      <!-- all three cells read the same (ruled 2026-09-14): the numbers
           already rank them, and orange here marked a CATEGORY, which the
           colour rule reserves for a task -->
      <div class="elg__cell"><span class="ko">실전 사용</span><b class="ko">+3점</b></div>
    </div>

    <p class="elg__h elg__h--lad ko">레벨</p>
    <ol class="elg__lad">
      <li v-for="r in rows" :key="r.lv" class="elg__l" :class="{ 'elg__l--now': r.lv === st.lv, 'elg__l--past': r.lv < st.lv }">
        <span class="elg__name ko">{{ r.name }}</span>
        <!-- no 지금 여기 chip (ruled 2026-09-13): the partial orange fill IS
             the marker — the bold name and the emphasized cap back it up -->
        <span class="elg__bar"><i :style="{ width: `${r.fill}%` }"></i></span>
        <span class="elg__th ko">{{ r.cap === null ? '최고 레벨' : `${r.cap}점` }}</span>
      </li>
    </ol>
    <!-- no remaining line here (ruled 2026-09-14): this block explains how
         points work. The member's own "one more to go" nudge belongs on the
         standing hero, where it sits beside their real number. -->
  </div>
</template>

<script>
import { LOOP_LADDER } from '@/services/engineLoop';
import { standing } from '@/services/engineStanding';

export default {
  name: 'EngineLevelGuide',
  data() { return { st: standing }; },
  computed: {
    /** Ascending, each stage a bar: full when the member passed its cap (the
     *  NEXT threshold — what "full" means there), partial on the current
     *  stage, empty ahead. The top stage has no cap. */
    rows() {
      const p = this.st.points;
      return LOOP_LADDER.map((r, i) => {
        const next = LOOP_LADDER[i + 1] || null;
        const cap = next ? next.threshold : null;
        let fill = 0;
        if (next && p >= next.threshold) fill = 100;
        else if (next && p > r.threshold) fill = Math.round(((p - r.threshold) / (next.threshold - r.threshold)) * 100);
        return { lv: r.lv, name: r.name, cap, fill: next ? fill : (this.st.lv === r.lv ? 100 : 0) };
      });
    },
  },
};
</script>

<style scoped>
.elg{text-align:left}
.elg__h{margin:0;font-size:11px;font-weight:800;letter-spacing:.04em;color:var(--faint,#8A8D95)}
.elg__h--lad{margin-top:18px}
/* 포인트: one strip, three cells — nothing else */
.elg__strip{display:flex;gap:6px;margin-top:8px}
.elg__cell{flex:1;display:flex;flex-direction:column;align-items:center;gap:2px;background:var(--raised2,#F2F3F6);border-radius:12px;padding:9px 0 8px}
.elg__cell span{font-size:11px;font-weight:700;color:var(--faint,#686A6F)}
.elg__cell b{font-size:14.5px;font-weight:850;color:var(--text,#191A1E);font-variant-numeric:tabular-nums}
/* 레벨: a bar per stage, the number at its end names "full" */
.elg__lad{list-style:none;margin:10px 0 0;padding:0;display:flex;flex-direction:column;gap:3px}
.elg__l{display:flex;align-items:center;gap:8px;padding:5px 0}
.elg__name{flex:none;width:86px;font-size:12.5px;font-weight:700;color:var(--faint,#8A8D95);letter-spacing:-.015em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.elg__l--past .elg__name{color:var(--muted,#4A4C52)}
.elg__l--now .elg__name{font-weight:850;color:var(--text,#191A1E)}
.elg__bar{flex:1;position:relative;height:8px;border-radius:99px;background:var(--raised2,#F2F3F6);overflow:hidden}
.elg__bar i{position:absolute;inset:0 auto 0 0;border-radius:99px;background:linear-gradient(180deg,#F79A57,var(--water,#F5893B) 55%);transition:width .6s var(--spring,cubic-bezier(.22,1,.36,1))}
.elg__th{flex:none;min-width:38px;text-align:right;font-size:11.5px;font-weight:750;color:var(--quat,#C0C2C8);font-variant-numeric:tabular-nums}
.elg__l--now .elg__th{color:var(--water-deep,#DE6F1B);font-weight:800}
</style>
